"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdHocTechnicalServices() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const services = [{
    number: "01",
    name: "Data Analytics",
    description: "Transform raw information into actionable intelligence with our advanced predictive modeling and custom dashboard development.",
    price: "FROM $2,500",
    path: "/DataAnalyticsPage"
  }, {
    number: "02",
    name: "Data Automation",
    description: "Streamline your operational workflows by eliminating manual data entry and integrating disparate software ecosystems.",
    price: "FROM $4,200",
    path: "/DataAutomationTechnologyPage"
  }];
  return;
}